import { render, staticRenderFns } from "./notice-messages.vue?vue&type=template&id=3e9940d8"
import script from "./notice-messages.vue?vue&type=script&lang=js"
export * from "./notice-messages.vue?vue&type=script&lang=js"
import style0 from "./notice-messages.vue?vue&type=style&index=0&id=3e9940d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports